var eventify = require('ngraph.events');
var bus = eventify({});

module.exports = bus;


// WEBPACK FOOTER //
// ./src/lib/bus.js